import StockItemDetailsPage from "./StockItemDetailsPage";

export default StockItemDetailsPage;